import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecommendedCoursesSection = ({ listings }) => {
  if (!listings || listings?.length === 0) return null;

  return (
    <div className="bg-white/30 backdrop-blur-xl rounded-xl p-4 sm:p-6 border border-white/40 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base sm:text-lg font-semibold text-foreground">Recommended for You</h3>
        <Link to="/course-catalog">
          <Button variant="ghost" size="sm" iconName="ArrowRight" iconPosition="right">
            View All
          </Button>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
        {listings?.map((listing) => (
          <Link
            key={listing?.courseId}
            to={`/course-preview?orgId=${listing?.providerId}&courseId=${listing?.courseId}`}
            className="flex gap-3 p-3 rounded-lg hover:bg-white/40 transition-colors"
          >
            <div className="w-16 h-16 rounded-lg overflow-hidden bg-muted flex-shrink-0 flex items-center justify-center">
              {listing?.thumbnailUrl ? (
                <img src={listing?.thumbnailUrl} alt={listing?.title} className="w-full h-full object-cover" />
              ) : (
                <Icon name="BookOpen" size={20} className="text-muted-foreground" />
              )}
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="font-medium text-foreground mb-1 line-clamp-2 text-sm">{listing?.title}</h4>
              <p className="text-xs sm:text-sm text-muted-foreground mb-2 truncate">{listing?.providerName}</p>

              <div className="flex items-center justify-between flex-wrap gap-1">
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="Layers" size={12} />
                    <span>{listing?.moduleCount || 0} modules</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="PlayCircle" size={12} />
                    <span>{listing?.lessonCount || 0} lessons</span>
                  </div>
                </div>
                <span className="text-xs font-medium text-foreground">
                  {listing?.isFree === false ? `${listing?.priceNesol} NESOL` : 'Free'}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-white/40">
        <Link to="/course-catalog">
          <Button variant="outline" fullWidth iconName="Search" iconPosition="left">
            Explore More Courses
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default RecommendedCoursesSection;